import React from 'react';
import styled, { css } from 'styled-components';

import { Nullable } from '@tager/web-core';
import { ThumbnailType } from '@tager/web-modules';

import { media } from '@/utils/mixin';

interface Props {
  avatar: Nullable<ThumbnailType>;
  authorName: Nullable<string>;
  authorText: Nullable<string>;
}

function Author({ avatar, authorName, authorText }: Props) {
  return (
    <Component>
      {avatar ? <Avatar photo={avatar.url} /> : null}
      <Content>
        <Name id="post-author">{authorName}</Name>
        <Info>{authorText}</Info>
      </Content>
    </Component>
  );
}

export default Author;

const Component = styled.div`
  display: flex;
  align-items: center;

  ${media.mobile(css`
    display: none;
  `)}
`;

const Avatar = styled.div<{ photo: Nullable<string> }>`
  overflow: hidden;
  width: 51px;
  height: 51px;
  margin-right: 10px;
  background-color: #c4c4c4;
  border-radius: 100%;

  ${({ photo }) =>
    photo &&
    css`
      background-image: url('${photo}');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    `};
`;

const Content = styled.div``;

const Name = styled.p`
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};
`;

const Info = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};
`;
